import firebase from 'firebase';
import firestore from 'firebase/firestore';
const firebaseApp = firebase.initializeApp(process.env.VUE_APP_FIREBASE);
firebaseApp.firestore().settings({timestampsInSnapshots: true});
export default firebaseApp.firestore();


// WEBPACK FOOTER //
// ./src/firebase/init.js